import * as React from 'react'
import { InteractiveGraphControllerContext } from '../graph/InteractiveGraphControllerProvider';


type Props = {
  children: any
}

const SelectedPathGuard: React.FC = ({ children }: Props) => {
  const graphController = React.useContext(InteractiveGraphControllerContext);

  const showChildren = !!graphController.selectedPath;

  return (
    <div>
      {showChildren &&
        children
      }
    </div>
  );
}

export default SelectedPathGuard;

